import { LoginResponseModel } from "features/login/data/model/responseModel/LoginResponseModel";
import { AppStartUpResponseEntity } from "./AppStartUpResponseEntity";

export class AppStartUpRequestEntity {
  user?: LoginResponseModel;
  language?: string;
  pathname?: string;
  isForceRefresh?: boolean;
  needBuildSidebar?: boolean;
  taskKeys?: string[];
  onBackgroundCompleted?: (
    response: AppStartUpResponseEntity,
  ) => void | Promise<void>;

  constructor(data?: Partial<AppStartUpRequestEntity>) {
    this.user = data?.user;
    this.language = data?.language;
    this.pathname = data?.pathname;
    this.isForceRefresh = data?.isForceRefresh;
    this.needBuildSidebar = data?.needBuildSidebar;
    this.taskKeys = data?.taskKeys;
    this.onBackgroundCompleted = data?.onBackgroundCompleted;
  }
}
